import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const stats = [
  { value: "24", unit: "集", label: "全剧完整分集" },
  { value: "6", unit: "位", label: "主要角色解析" },
  { value: "6", unit: "篇", label: "深度剧情解读" },
  { value: "100%", unit: "", label: "多设备自适应" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium font-label mb-4">
            <i className="ri-information-line"></i>
            关于本站
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            一部剧，两个入口，看懂全部
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {siteInfo.description}
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            无论你是想快速找到某一集，还是想深入理解角色的每一次选择，这里都能给你一个清晰、舒适的浏览与阅读体验。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-play-list-2-line"></i>
              开始追剧
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              联系我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-5">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-baseline gap-1">
                <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">
                  {stat.value}
                </span>
                {stat.unit && (
                  <span className="text-sm font-medium text-primary-500">{stat.unit}</span>
                )}
              </div>
              <p className="mt-2 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}